module.exports = __webpack_public_path__ + "static/himmel-und-holle-04-56935336947a981d3fd421ed0cd7b027.jpg";